// src/stores/useAnalyticsProductsStore.js
import { create } from "zustand";
import { fetchWithAuth } from "../api/fetchWithAuth";

/**
 * Caches the list of analytics products the active org is entitled to.
 *
 * Loaded once on org-context resolution. Refreshed when the user changes
 * orgs (handled by call sites). Used by TopNav to filter the mode list.
 */
export const useAnalyticsProductsStore = create((set) => ({
    products: [],
    productCodes: new Set(),
    bundleActive: false,
    loaded: false,

    load: async () => {
        try {
            const res = await fetchWithAuth("/api/v1/analytics/products/available");
            if (!res.ok) {
                set({ loaded: true });
                return;
            }
            const data = await res.json();
            set({
                products: data.products || [],
                productCodes: new Set((data.products || []).map((p) => p.product_code)),
                bundleActive: !!data.bundle_active,
                loaded: true,
            });
        } catch (err) {
            console.error("[analytics-products] load failed", err);
            set({ loaded: true });
        }
    },

    clear: () =>
        set({
            products: [],
            productCodes: new Set(),
            bundleActive: false,
            loaded: false,
        }),
}));

// Register with userBoundary so an in-tab user-switch flushes the
// previous user's product codes — the TopNav reads productCodes to
// filter the mode list, and the previous user's codes leaking through
// is one of the three known user-boundary leakage bugs this hook fixes.
// The refetch reloads the incoming user's entitled products, so TopNav's
// mode tabs repopulate without a page refresh.
import { registerUserBoundaryReset } from "../auth/userBoundary";
registerUserBoundaryReset(
  () => useAnalyticsProductsStore.getState().clear(),
  () => useAnalyticsProductsStore.getState().load(),
);